import httpManager from "../../../utils/httpManager";

/** Identificadores asignados a Agentes IA: { [channelCustomerId]: { bot_id, name } } */
export async function fetchAgentAIIdentifiers() {
  const response = await httpManager.get("/beexai/bots/identifiers/");
  return response.data?.identifiers || {};
}
